import styles from './Spinner.module.css';

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
};

/** Spinner — accessible loading indicator. Respects prefers-reduced-motion (tokens.css). */
export default function Spinner({ size = 'md', label = 'Loading…' }: SpinnerProps) {
  return (
    <span className={styles.wrap} role="status" aria-label={label}>
      <span className={`${styles.spinner} ${styles[size]}`} aria-hidden="true" />
    </span>
  );
}
